export const getReservableIntervalPrice = ({ selectedInterval, }) => {
    return (selectedInterval.price.value *
        (selectedInterval.price.shouldScaleWithNrOfPersons
            ? selectedInterval.numberOfPersons
            : 1));
};
